var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "216px",
    height: "33px",
    viewBox: "0 0 216 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo / imagen / light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-/-imagen-/-light",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "65.8692 30.7482 72.9042 30.7482 83.4782 8.1302 79.9412 0.6022"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#CCD520",
    points: "94.0113 30.7482 101.0473 30.7482 97.5293 23.2112"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#84CE25",
    points: "94.0122 15.6754 97.5302 23.2114 90.4942 23.2114"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#B8CC27",
    points: "90.4941 23.2116 94.0121 30.7486 97.5291 23.2116"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#42C642",
    points: "90.4941 23.2116 94.0121 15.6756 86.9761 15.6756"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#2AC4B5",
    points: "90.4941 8.1388 94.0121 15.6758 86.9761 15.6758"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#229EBA",
    points: "86.9766 15.6754 90.4946 8.1384 83.4586 8.1394"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#1C80B7",
    points: "86.9766 0.6027 90.4946 8.1387 83.4586 8.1387"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#1B75B8",
    points: "83.459 8.1388 86.977 0.6028 79.941 0.6028"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFFFFF",
    points: "0 30.7482 5.944 30.7482 5.944 0.6032 0 0.6032"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#FFFFFF",
    points: "47.8566 0.6027 39.2446 14.8567 30.5876 0.6027 24.4716 0.6027 24.4716 30.7487 30.4156 30.7487 30.4156 11.2417 38.8966 25.1947 39.5886 25.1947 48.0706 11.1957 48.0706 30.7487 53.9726 30.7487 53.9726 0.6027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(109.574100, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.962,16.88 C30.962,25.58 24.804,31.351 16.15,31.351 C6.718,31.351 0,24.331 0,15.719 C0,6.978 6.806,0 15.807,0 C18.189,0 20.423,0.499 22.402,1.38 C23.969,2.078 25.377,3.015 26.572,4.132 C27.496,4.996 28.293,5.967 28.939,7.02 L23.858,9.947 C23.056,8.544 21.686,7.36 19.959,6.615 C18.717,6.08 17.292,5.771 15.761,5.771 C10.035,5.771 5.901,9.989 5.901,15.719 C5.901,21.316 9.905,25.537 16.192,25.537 C20.93,25.537 23.945,23.255 24.976,19.811 L17.204,19.811 L14.751,14.555 L30.962,14.555 L30.962,16.88 Z",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    points: "65.9259 25.0641 65.9259 30.7481 47.2789 30.7481 47.2789 0.6031 65.7119 0.6031 65.7119 6.2871 53.2219 6.2871 53.2219 12.7041 64.6349 12.7041 64.6349 18.3031 53.2219 18.3031 53.2219 25.0641"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    points: "106.4259 0.6027 106.4259 30.7487 101.9029 30.7487 88.9849 12.3177 88.9849 30.7487 83.0409 30.7487 83.0409 0.6027 87.5649 0.6027 100.4829 18.9907 100.4829 0.6027"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagenLogo);
export default __webpack_public_path__ + "static/media/imagen_logo.82982e3f1ebe9f7a919148d224507505.svg";
export { ForwardRef as ReactComponent };